import { SET_ERROR, SET_WARNING_WIDTH, SET_WARNING_HEIGHT } from '../constants/validatorConstants';

const popupReducer = (state: any, action: any) => {
    switch (action.type) {
        case SET_ERROR:
            return {
                ...state,
                error: action.error
            }
        case SET_WARNING_WIDTH:
            return {
                ...state,
                warningWidth: action.warningWidth
            }
        case SET_WARNING_HEIGHT:
            return {
                ...state,
                warningHeight: action.warningHeight
            }
        default:
            return { ...state };
    }
};

export default popupReducer;